import { apiRequest } from "@nusrif/utils";
import { ApiPaymentResponse } from "@nusrif/types";

/**
 * Create a new cart for the authenticated user
 */
export async function createPayment(orderId: string): Promise<ApiPaymentResponse> {
    const response = await apiRequest<ApiPaymentResponse>('/payments', {
        method: 'POST',
        body: {
            orderId
        }
    });

    return response;
}

/**
 * Verify the payment status for a given orderId
 */
export async function verifyPayment(orderId: string): Promise<ApiPaymentResponse> {
    const response = await apiRequest<ApiPaymentResponse>('/payments/verify', {
        method: 'POST',
        body: {
            orderId
        }
    });

    return response;
}